import { render } from "./PeekPurchase.vue?vue&type=template&id=38972f3a"
import script from "./PeekPurchase.vue?vue&type=script&lang=js"
export * from "./PeekPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__